(function () {
    "use strict";

    angular.module("app").component("detailHeaderPerson", {
        templateUrl: "@/detailHeader/detail-header-person.html",
        bindings: {
            request: "=",
            index: "=",
            override: "=?"
        },
        controller: DetailHeaderPersonController
    });

    DetailHeaderPersonController.$inject = ["HabilNavigator", "ivmRequestHelper",];
    function DetailHeaderPersonController(HabilNavigator, ivmRequestHelper) {
        const $controller = Object.assign(this, {
            GetLabel,
            GetIcon,
            GetStyle,
            OpenDossier,
            OpenOrganisation
        });

        function GetLabel() {
            return getInitialActionText();
        }

        function getInitialActionText() {
            if ($controller.override)
                return $controller.override;

            return ivmRequestHelper.GetInitialActionText($controller.request);
        }

        function GetIcon() {
            return ivmRequestHelper.GetInitialActionIcon($controller.request);;
        }

        function GetStyle() {
            if (!$controller.request)
                return "";

            if ($controller.request.Deleted) {
                return "alert alert-danger";
            }

            if ($controller.request.IsForeign) {
                return "well-foreign";
            }
        }

        function OpenDossier() {
            HabilNavigator.OpenDossierPerson($controller.request.DossierPublicId);
        }

        function OpenOrganisation() {
            HabilNavigator.OpenDossierOrganisation($controller.request.OrganisationDossierHeader.PublicId);
        }
    }
})();